

























import CandleImage from "./CandleImage.vue";
import emojiRegex from "emoji-regex";
import { Component, Vue } from "vue-property-decorator";
import Candle from "@/models/candle";

@Component({
  components: {
    CandleImage,
  },
  watch: {
    newCandleName: function () {
      const instance = this as CreateCandle;
      instance.updateInputValidation();
    },
  },
})
export default class CreateCandle extends Vue {
  private static readonly validNameRegex = /^[^(\d|(\r?\n|\r))]+$/;
  private static readonly invalidEmogiRegex = emojiRegex();

  private isActive = false;
  private validationMessage = "";

  private newCandle: Candle = {
    name: "",
  };

  get candleSize() {
    return this.isActive ? "big" : "normal";
  }

  get newCandleName() {
    return this.newCandle.name;
  }

  handleClick() {
    if (!this.isActive) {
      this.isActive = true;
      this.$emit("active", true);
    } else if (this.isActive && this.newCandle.name) {
      this.confirmLightCandle();
    } else {
      this.isActive = false;
      this.$emit("active", false);
    }
  }

  handleEnter() {
    if (this.isActive && this.newCandle.name) {
      this.confirmLightCandle();
    }
  }

  confirmLightCandle() {
    if (!this.validationMessage) {
      this.$modal.show("dialog", {
        name: "dialog",
        title: "Light Candle?",
        text: `Light a candle for ${this.newCandle.name}?`,
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              this.$modal.hide("dialog");
            },
          },
          {
            title: "Light",
            handler: () => {
              this.$modal.hide("dialog");
              this.lightCandle();
            },
          },
        ],
      });
    }
  }

  lightCandle() {
    this.$emit("light-candle", this.newCandle);
  }

  updateInputValidation() {
    if (
      !CreateCandle.validNameRegex.test(this.newCandleName) ||
      CreateCandle.invalidEmogiRegex.test(this.newCandleName)
    ) {
      this.validationMessage = "The input name is invalid.";
    } else {
      this.validationMessage = "";
    }
  }
}
